import { useEffect, useState } from "react";
import * as Scrivito from "scrivito";
import { Item, Items, InternalItems } from "./Items";

// get headline widgets with and anchor set inside a container (section or page content) of the current widget
const getPageAnchors = (container) => {
  if (!container) {
    return [];
  }
  const allWidgets = container.widgets();
  return allWidgets
    .filter((widget) => widget.objClass() === "HeadlineWidget")
    .filter((widget) => !!widget.get("anchor"));
};

// get a container (section or page content) for the current widget
const closestSectionContainer = (widget, currPage) => {
  if (!widget) return null;

  if (widget.id() === currPage?.id()) {
    return widget;
  }

  const container = widget.container?.();
  if (!container) return widget;

  if (container.objClass?.() === "SectionContentWidget") {
    return container;
  }

  return closestSectionContainer(container);
};

export const get = (widget, options, field, fallback) => {
  if (widget?.get) return widget.get(field);
  return options[field] ?? fallback;
};

export const DesktopNav = Scrivito.connect(({ widget, options }) => {
  const currPage = Scrivito.currentPage();
  const internal = get(widget, options, "internal", false);
  const elements = get(widget, options, "elements", []);
  const [container, setContainer] = useState(null);

  useEffect(() => {
    if (widget) {
      setContainer(closestSectionContainer(widget, currPage));
    }
  }, [currPage, widget]);

  const asChildList =
    elements.length === 0 &&
    !internal &&
    get(widget, options, "items", []).length === 0; // the last check is for backwards compatibility, will be removed in the future
  const oldItems =
    get(widget, options, "items", []).map((w) => w.get("link")) || [];
  const items = internal ? getPageAnchors(container) : elements;
  const ListComponent = internal ? InternalItems : Items;
  const actualItems = items.length > 0 ? items : oldItems;

  return asChildList ? (
    <Scrivito.ChildListTag
      className="inpage-navigation"
      parent={get(widget, options, "childsFrom", null) || currPage}
      renderChild={(child) =>
        child.get("hideInNavigation") !== "yes" && (
          <Item item={child} currPage={currPage} />
        )
      }
      tag="div"
    />
  ) : (
    <div className="inpage-navigation">
      <ListComponent items={actualItems} currPage={currPage} />
    </div>
  );
});

export const MobileNav = Scrivito.connect(({ widget, options }) => {
  const [open, setOpen] = useState(false);
  const currPage = Scrivito.currentPage();
  const lang = currPage.language();

  return (
    <div className="inpage-navigation-mobile">
      <button
        className="inpage-navigation-mobile__toggle"
        onClick={() => setOpen(!open)}
        aria-label="Toggle navigation"
        aria-expanded={open}
        aria-controls="inpage-navigation-mobile"
        title="Toggle navigation"
        type="button"
      >
        {open ? (
          <>
            <i className="las la-angle-double-up" />{" "}
            {lang === "de" ? "Navigation schließen" : "Close Navigation"}
          </>
        ) : (
          <>
            <i className="las la-angle-double-down" />{" "}
            {lang === "de" ? "Navigation öffnen" : "Open Navigation"}
          </>
        )}
      </button>
      {open && <DesktopNav widget={widget} options={options} />}
    </div>
  );
});
